export default "__VITE_ASSET__BFMoV5aP__"